import { defineMessages } from 'react-intl'

const translations = defineMessages({
  myAddresses: {
    defaultMessage: 'My Addresses',
    id: 'global.account.link.addresses'
  },
  editAddress: {
    defaultMessage: 'Edit Address',
    id: 'msp.shipping_address_selection.heading.edit_address'
  },
  saveChanges: {
    defaultMessage: 'Save changes',
    id: 'global.save.changes'
  },
  addNewAddressMessage: {
    defaultMessage: 'Add New Address',
    id: 'msp.shipping_address_selection.button.add_address'
  },
  preferredAddress: {
    defaultMessage: 'Default Address',
    id: 'msp.shipping_address_selection.default_address'
  },
  addressRemoveTitle: {
    defaultMessage: 'Confirm deletion',
    id: 'msp.shipping_address_remove.title'
  },
  addressRemoveDescription: {
    defaultMessage: 'Address',
    id: 'msp.shipping_address_remove.description'
  },
  addressRemoveNote: {
    defaultMessage:
      'Note: Deleting this address will not cancel any pending orders sent to this address. Please check and update your Darq subscriptions that are linked to this address to ensure future orders are properly processed.',
    id: 'msp.shipping_address_remove.note'
  },
  addressRemoveCancel: {
    defaultMessage: 'Cancel',
    id: 'msp.shipping_address_remove.cancel'
  },
  addressRemoveConfirm: {
    defaultMessage: 'Confirm deletion',
    id: 'msp.shipping_address_remove.confirm'
  },
  noAddresses: {
    defaultMessage: `You don't have any saved addresses, you can add one by clicking on the add button below.`,
    id: 'msp.account.no_shipping_addresses'
  },
  placeholderHeading: {
    defaultMessage: `You don't have any saved addresses yet.`,
    id: 'msp.account.shipping_address.placeholder.no_order_yet'
  },
  placeholderText: {
    defaultMessage: 'You can add one by clicking on the add button below.',
    id: 'msp.account.shipping_address.placeholder.text'
  }
})

export default translations
